import React from 'react'
import '../../../../App.scss';
import Grid from "@material-ui/core/Grid";
import ButtonBackground from '../../../../assets/images/empty_wood_btn.png'
import Badge from '../../../pageComponents/Home/GiftHall/Badge'
import Clock from '../../../../assets/images/clocks.png'
class Divider extends React.Component{
    constructor() {
        super()
        this.state={
            conditionValue:0
        }
    }
    componentDidMount() {
        const {countTrue,maxConditionValue}=this.props.data
    }
    render() {
        const{data}=this.props
        const {conditionValue}=this.state
        const {countTrue,maxConditionValue}=this.props.data
        return (
            <Grid className='divider-first' container alignItems={"center"} justify={"center"}>
                <Grid className='divider-second' container alignItems={"flex-end"} justify={"center"}>
                    <Grid className='divider-third' container alignItems={"flex-end"}
                          style={{alignSelf:'flex-start',marginBottom:'10px',height:`${countTrue}%`}} justify={"center"}/>
                    <Grid container style={{position:'absolute',width:'200%',transform:'translateY(-10%)'}}>
                        <Badge data={data}/>
                    </Grid>
                </Grid>
            </Grid>

        )
    }
}
export default Divider